/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CcmAccountStatusEnum = 'ACTIVE' | 'INACTIVE';

export const CcmAccountStatusEnum = {

    ACTIVE: 'ACTIVE' as CcmAccountStatusEnum,

    INACTIVE: 'INACTIVE' as CcmAccountStatusEnum
};

